var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"qrcode"},[_c('qrcode',{attrs:{"value":_vm.json,"options":{
      errorCorrectionLevel: 'Q',
      width: 200,
    }}}),_c('img',{staticClass:"qrcode__image",attrs:{"src":"/dole.jpg","alt":"Chen Fengyuan"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }